import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { ManagerUpdateNotification } from '../models/leave.model';
import { LeaveService } from './leave.service';

@Injectable({ providedIn: 'root' })
export class ManagerUpdatesService {
  private readonly leaveService = inject(LeaveService);

  readonly notifications$ = new BehaviorSubject<ManagerUpdateNotification[]>([]);
  readonly loading$ = new BehaviorSubject<boolean>(false);

  loadNotifications(): void {
    this.loading$.next(true);

    this.leaveService.getManagerUpdates()
      .pipe(finalize(() => this.loading$.next(false)))
      .subscribe({
        next: (notifications) => {
          this.notifications$.next(notifications ?? []);
        },
        error: (err) => {
          console.error('[ManagerUpdatesService] loadNotifications error:', err);
          this.notifications$.next([]);
        },
      });
  }
}
